import {getDateFromIsoString} from '@shared/api';
import {getLocalizedText} from '@shared/utils';
import {Currency, CurrencyEventSchedule, EventTemplate} from '../types';
import {
  CurrencyEventScheduleOnBackend,
  CurrencyOnBackend,
  EventTemplateOnBackend,
} from './backendTypes';

export const mapCurrencyFromBackend = ({
  id,
  slug,
  coingecko_id,
  coingecko_network,
  coingecko_token_address,
  is_active,
}: CurrencyOnBackend): Currency => ({
  id,
  slug,
  coingeckoId: coingecko_id,
  coingeckoNetwork: coingecko_network,
  coingeckoTokenAddress: coingecko_token_address,
  isActive: is_active,
});

export const mapEventTemplateFromBackend = ({
  id,
  type,
  templates,
}: EventTemplateOnBackend): EventTemplate => ({
  id,
  type,
  name: getLocalizedText(templates?.name) || type,
});

export const mapCurrencyEventScheduleFromBackend = ({
  id,
  currency_id,
  currency_slug,
  template_id,
  template_type,
  cron,
  next_run_at,
}: CurrencyEventScheduleOnBackend): CurrencyEventSchedule => ({
  id,
  currencyId: currency_id,
  currencySlug: currency_slug,
  templateId: template_id,
  templateType: template_type,
  cron,
  nextRunAt: getDateFromIsoString(next_run_at),
});
